document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.pet-btn').forEach(initPetButton);
});

// Handles buttons added later (quick add modals, section re-renders)
document.addEventListener('shopify:section:load', () => {
  document.querySelectorAll('.pet-btn:not([data-pet-bound])').forEach(initPetButton);
});

function initPetButton(button) {
  if (button.dataset.petBound) return;
  button.dataset.petBound = 'true';

  const textEl = button.querySelector('.btn-text');
  const originalText = textEl ? textEl.textContent.trim() : '';
  let leaveTimer;
  let addedTimer;

  function restartAnimationClass(className) {
    button.classList.remove(className);
    void button.offsetWidth;
    button.classList.add(className);
  }

  function startHoverAnimation() {
    clearTimeout(leaveTimer);
    button.classList.remove('is-leaving');
    button.classList.remove('is-hovered');
    void button.offsetWidth;
    button.classList.add('is-hovered');
  }

  function endHoverAnimation() {
    button.classList.remove('is-hovered');
    button.classList.add('is-leaving');
    leaveTimer = setTimeout(() => {
      button.classList.remove('is-leaving');
    }, 300);
  }

  function onClick() {
    restartAnimationClass('is-clicking');
    setTimeout(() => button.classList.remove('is-clicking'), 560);
  }

  // Defensive safeguard: if a variant swap or section re-render ever causes
  // the server-rendered markup to be inserted alongside the existing button
  // content (instead of replacing it) — e.g. from an id collision on
  // ProductSubmitButton-{{ section.id }} — this strips any duplicate
  // structural children so the button never visibly doubles up.
  function dedupeChildren() {
    const dupSelectors = ['.btn-text', '.hover-fill', '.click-ripple', '.paw-layer', '.loading-overlay'];
    dupSelectors.forEach((sel) => {
      const nodes = button.querySelectorAll(`:scope > ${sel}`);
      if (nodes.length > 1) {
        // Keep the first, remove the rest
        for (let i = 1; i < nodes.length; i++) {
          nodes[i].remove();
        }
      }
    });
  }

  dedupeChildren();

  button.addEventListener('mouseenter', startHoverAnimation);
  button.addEventListener('mouseleave', endHoverAnimation);
  button.addEventListener('focus', startHoverAnimation);
  button.addEventListener('blur', endHoverAnimation);
  button.addEventListener('click', onClick);

  // Watch Dawn's own loading/aria-disabled state instead of a timer,
  // so the text change matches the real add-to-cart request.
  let wasLoading = false;
  const observer = new MutationObserver((mutations) => {
    // Re-run the dedupe guard whenever the button's subtree changes
    // (e.g. after Dawn morphs in fresh markup on a variant change).
    const hadChildListChange = mutations.some((m) => m.type === 'childList');
    if (hadChildListChange) {
      dedupeChildren();
    }

    const isLoading = button.classList.contains('loading');

    if (isLoading && !wasLoading && textEl) {
      textEl.textContent = 'ADDING…';
    }

    if (!isLoading && wasLoading && textEl) {
      const hadError = button.closest('product-form')
        ?.querySelector('.product-form__error-message-wrapper')
        ?.hasAttribute('hidden') === false;

      if (!hadError) {
        button.classList.add('is-added');
        textEl.textContent = '✓ ADDED';
        clearTimeout(addedTimer);
        addedTimer = setTimeout(() => {
          button.classList.remove('is-added');
          textEl.textContent = originalText;
        }, 1800);
      } else {
        textEl.textContent = originalText;
      }
    }

    wasLoading = isLoading;
  });

  observer.observe(button, { attributes: true, attributeFilter: ['class'], childList: true, subtree: false });
}
